import { Action, createReducer, on } from '@ngrx/store';
import { SnmpVaultControllerFindAll$Params } from '../../../api/functions';
import { CounterResponse, EmptyResponse, SnmpVaultItem, SnmpVaultListResponse } from '../../../api/models';
import { ILoaderActionPayload, LoadingState } from '../models/loader.model';
import { snmpVaultActions } from './snmp-vault.action';

export interface SnmpVaultState {
  list: {
    state: ILoaderActionPayload;
    data?: SnmpVaultListResponse;
    request?: SnmpVaultControllerFindAll$Params;
  };
  single: {
    state: ILoaderActionPayload;
    data?: SnmpVaultItem;
  };
  saveOne: { state: ILoaderActionPayload; data?: SnmpVaultItem };
  createOne: { state: ILoaderActionPayload; data?: SnmpVaultItem };
  deleteOne: { state: ILoaderActionPayload; data?: EmptyResponse };
  addPrinters: { state: ILoaderActionPayload; data?: CounterResponse };
}

const initialState: SnmpVaultState = {
  list: { state: { value: LoadingState.NONE } },
  single: { state: { value: LoadingState.NONE } },
  saveOne: { state: { value: LoadingState.NONE } },
  createOne: { state: { value: LoadingState.NONE } },
  deleteOne: { state: { value: LoadingState.NONE } },
  addPrinters: { state: { value: LoadingState.NONE } },
};

const reducer = createReducer(
  initialState,
  on(snmpVaultActions.load, (state) => ({
    ...state,
    list: { state: { value: LoadingState.LOADING } },
  })),
  on(snmpVaultActions.done, (state, props) => ({
    ...state,
    list: { state: props.state, data: props.data },
  })),
  on(snmpVaultActions.loadOne, (state) => ({
    ...state,
    single: { state: { value: LoadingState.LOADING } },
  })),
  on(snmpVaultActions.loadOneDone, (state, props) => ({
    ...state,
    single: { state: props.state, data: props.data },
  })),
  on(snmpVaultActions.create, (state) => ({
    ...state,
    createOne: { state: { value: LoadingState.LOADING } },
  })),
  on(snmpVaultActions.createDone, (state, props) => ({
    ...state,
    createOne: { state: props.state, data: props.data },
  })),
  on(snmpVaultActions.createSetState, (state, props) => ({
    ...state,
    createOne: { state: props.state },
  })),
  on(snmpVaultActions.edit, (state) => ({
    ...state,
    saveOne: { state: { value: LoadingState.LOADING } },
  })),
  on(snmpVaultActions.editDone, (state, props) => ({
    ...state,
    saveOne: { state: props.state, data: props.data },
  })),
  on(snmpVaultActions.editSetState, (state, props) => ({
    ...state,
    saveOne: { state: props.state },
  })),
  on(snmpVaultActions.delete, (state) => ({
    ...state,
    deleteOne: { state: { value: LoadingState.LOADING } },
  })),
  on(snmpVaultActions.deleteDone, (state, props) => ({
    ...state,
    deleteOne: { state: props.state, data: props.data },
  })),
  on(snmpVaultActions.deleteSetState, (state, props) => ({
    ...state,
    deleteOne: { state: props.state },
  })),
  on(snmpVaultActions.connectManyPrinters, (state) => ({
    ...state,
    addPrinters: { state: { value: LoadingState.LOADING } },
  })),
  on(snmpVaultActions.connectManyPrintersDone, (state, props) => ({
    ...state,
    addPrinters: { state: props.state, data: props.data },
  })),
  on(snmpVaultActions.connectManyPrintersSetState, (state, props) => ({
    ...state,
    addPrinters: { state: props.state },
  })),
);

export function snmpVaultReducer(state: SnmpVaultState | undefined, action: Action) {
  return reducer(state, action);
}
